import { css } from 'styled-components';

/**
 * Hover/cursor treatment for an actionable VariablePill — used only via ClickableVariablePill so
 * every surface (scenario screen, form chips, AI wizard) reads identically: pointer cursor, a
 * single state-coloured 1px accent line on hover (blue when populated, red when unpopulated) plus
 * a soft shadow — no movement. Pills that draw a real border (bordered, or unpopulated which always
 * has the red border) get it by recolouring that border; borderless pills (AI wizard) get the same
 * visual via a 1px inset ring, so there's no layout shift and no styling drift between surfaces.
 *
 * `.vp-icon svg` overrides InfoIcon's `cursor:default` (0-1-1 beats its 0-1-0 class).
 */
export const clickablePillCss = (unpopulated?: boolean, bordered = true) => css`
  cursor: pointer;
  transition: box-shadow 120ms ease, border-color 120ms ease;

  &:hover {
    ${unpopulated || bordered
      ? css`
          border-color: ${({ theme }) => (unpopulated ? theme.colors.statusRed : theme.colors.prussianBlue)};
          box-shadow: 0 2px 6px rgba(31, 58, 95, 0.12);
        `
      : css`
          box-shadow:
            inset 0 0 0 1px ${({ theme }) => theme.colors.prussianBlue},
            0 2px 6px rgba(31, 58, 95, 0.12);
        `}
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.gp1};
    outline-offset: 2px;
  }
  .vp-icon svg {
    cursor: pointer;
  }
`;
